import { combineReducers } from 'redux';
import auth from './auth';
import conversations from './conversations';
import chat from './chat';
import superuser from './superuser';

const rootReducer = combineReducers({
  auth,
  conversations,
  chat,
  superuser
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js